import { useEffect } from 'react';
import { Network } from '@capacitor/network';
import { PluginListenerHandle } from '@capacitor/core';

export const useOnNetworkStatus = (onConnectedCallback: () => void) => {
	useEffect(() => {
		let listenerHandle: PluginListenerHandle | null = null;

		const setupListener = async () => {
			listenerHandle = await Network.addListener('networkStatusChange', async (status) => {
				if (status.connected) {
					try {
						onConnectedCallback();
					} catch (error) {
						console.error('useOnNetworkStatusOnline error', error);
					}
				}
			});
		};

		void setupListener();

		return () => {
			if (listenerHandle) {
				void listenerHandle.remove();
			}
		};
	}, [onConnectedCallback]);
};
